/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Docx_DocxInputs */

const en_docx_docx = /** @type {(inputs: Docx_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DocX (.docX)`)
};

const fr_docx_docx = /** @type {(inputs: Docx_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DocX (.docX)`)
};

const de_docx_docx = /** @type {(inputs: Docx_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DocX (.docX)`)
};

const it_docx_docx = /** @type {(inputs: Docx_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DocX (.docX)`)
};

const ru_docx_docx = /** @type {(inputs: Docx_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DocX (.docX)`)
};

const es_docx_docx = /** @type {(inputs: Docx_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DocX (.docX)`)
};

const zh_cn2_docx_docx = /** @type {(inputs: Docx_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DocX (.docX)`)
};

const ja_docx_docx = /** @type {(inputs: Docx_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DocX (.docX)`)
};

const hi_docx_docx = /** @type {(inputs: Docx_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DocX (.docX)`)
};

const pt_pt2_docx_docx = /** @type {(inputs: Docx_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DocX (.docX)`)
};

/**
* | output |
* | --- |
* | "DocX (.docX)" |
*
* @param {Docx_DocxInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const docx_docx = /** @type {((inputs?: Docx_DocxInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Docx_DocxInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_docx_docx(inputs)
	if (locale === "de") return de_docx_docx(inputs)
	if (locale === "it") return it_docx_docx(inputs)
	if (locale === "ru") return ru_docx_docx(inputs)
	if (locale === "es") return es_docx_docx(inputs)
	if (locale === "zh-CN") return zh_cn2_docx_docx(inputs)
	if (locale === "ja") return ja_docx_docx(inputs)
	if (locale === "hi") return hi_docx_docx(inputs)
	if (locale === "pt-PT") return pt_pt2_docx_docx(inputs)
	return en_docx_docx(inputs)
});